/**
 * School-level data retention cutoff from GET /schools/active.
 * Backend computes this from the CSA preference and returns a UTC datetime.
 */
const LAST_DATE_TO_KEEP_DATA_KEY = "last_date_to_keep_data"

const SCHOOL_YEAR_START_MONTH = 6 // July, 0-indexed
const SCHOOL_YEAR_START_DAY = 1

const MIN_PRIOR_SCHOOL_YEARS = 0
const MAX_PRIOR_SCHOOL_YEARS = 4

export default {
  LAST_DATE_TO_KEEP_DATA_KEY,
  SCHOOL_YEAR_START_MONTH,
  SCHOOL_YEAR_START_DAY,
  MIN_PRIOR_SCHOOL_YEARS,
  MAX_PRIOR_SCHOOL_YEARS
}
